import { useState } from "react";
import axios from "../axios";
import { toast } from "sonner";

export const useSelectBranch = () => {
  const [loading, setLoading] = useState(false);

  const selectBranch = async (brandId, branchId) => {
    try {
      setLoading(true);
      const response = await axios.put(
        "/audiences/select-branch",
        JSON.stringify({
          brand_id: brandId,
          branch_id: branchId,
        }),
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("arena_xp_token")}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Branch selected successfully");
        return true;
      }
    } catch (error) {
      console.error("Error selecting branch:", error);
      if (error.response?.status === 404) {
        toast.error(error.response.data.message || "Branch not found");
      } else if (error.response?.status === 422) {
        toast.error(error.response.data.message || "Invalid data provided");
      } else {
        toast.error("Failed to select branch. Please try again.");
      }
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { selectBranch, loading };
};